/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { createContext, type ForwardedRef, forwardRef, type ReactElement } from 'react';
import { type ContextValue, Menu as MenuCore, type MenuProps as MenuCoreProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface MenuProps<T> extends Omit<MenuCoreProps<T>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const MenuContext = createContext<ContextValue<MenuProps<object>, HTMLDivElement>>({});

const Menu = forwardRef((props: MenuProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, MenuContext);

  const { style, children, ...coreProps } = props;

  return (
    <MenuCore
      ref={ref}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      {children}
    </MenuCore>
  );
}) as <T>(p: MenuProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    padding: 4,
    borderColor: $.border08,
    borderRadius: 10,
    borderStyle: 'solid',
    borderWidth: 1,
    outline: 'none',
    overflow: 'auto',
    backgroundColor: $.surfaceBGPrimary,
    boxShadow: $.shadowBottom060Medium,
    boxSizing: 'border-box',
    maxHeight: 'inherit',
  },
});

export { Menu, MenuContext, type MenuProps };
